import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses, Bonus } from '../data/bonuses';
import { optimizedImage } from '../utils/image';
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-6 bg-navy py-10 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-14" data-mp="vtfiou94u1g0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-15" data-mp="qt07o9cbp617">
        <SectionHeading eyebrow="Included free" title={<span id="bonuses-heading" data-id="element-17" data-mp="14sj5a87icyz9">+ 5 practical coaching bonuses</span>} lead="Practical tools designed to solve real problems before and during practice." data-id="element-16" data-mp="qw5u1gtkhtt8" />

        <ul className="mt-8 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-18" data-mp="1ejdzpzuwr4vs">
          {bonuses.map((bonus, index) => {
          const isLastOdd = index === bonuses.length - 1 && bonuses.length % 2 === 1;
          return <BonusCard key={bonus.number} bonus={bonus} className={isLastOdd ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.5rem)]' : ''} data-id="element-19" data-mp="1njsppcith85m" data-mpi={index} />;
        })}
        </ul>
      </div>
    </section>;
}
interface BonusCardProps {
  bonus: Bonus;
  className?: string;
}

/** Cover fills the full card height on the left, details on the right. */
function BonusCard({
  bonus,
  className = ''
}: BonusCardProps) {
  return <li className={`flex min-h-[10.5rem] overflow-hidden rounded-2xl border border-line bg-ink ${className}`} data-id="element-20" data-mp="2lvtek1fy9nk">
      <div className="relative w-[38%] max-w-[11rem] shrink-0" style={{
      backgroundColor: `${bonus.color}1a`
    }} data-id="element-21" data-mp="7l8k5fvfo0vf">
        <img src={optimizedImage(bonus.image, 360)} alt={`${bonus.title} cover`} className="absolute inset-0 h-full w-full object-cover" width={360} height={360} loading="lazy" decoding="async" data-id="element-22" data-mp="cj0jguyeqp9n" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col border-l-[3px] px-3.5 py-3 sm:px-4 sm:py-3.5" style={{
      borderColor: bonus.color
    }} data-id="element-23" data-mp="lcndafj21ig7">
        <div className="flex items-center gap-2" data-id="element-24" data-mp="va9rezsj55z4">
          <span className="font-display text-xs font-bold uppercase tracking-[0.16em]" style={{
          color: bonus.color
        }} data-id="element-25" data-mp="vbupgze1z71q">
            Bonus {bonus.number}
          </span>
          <span className="rounded-full bg-cta px-2 py-0.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.12em] text-on-accent" data-id="element-26" data-mp="ama87vrlw09r">
            Free
          </span>
        </div>
        <h3 className="mt-0.5 font-display text-lg font-extrabold uppercase leading-[1.05] text-fg sm:text-xl" data-id="element-27" data-mp="kbaf01ccnzyi">
          {bonus.title}
        </h3>
        {bonus.intro ? <p className="mt-1 text-[0.82rem] leading-snug text-fg/90" data-id="element-28" data-mp="tbqdewe8kgwi">{bonus.intro}</p> : null}
        {bonus.items ? <p className="mt-1 text-[0.78rem] leading-snug text-muted" data-id="element-29" data-mp="ocvw5yvx30ei">
            {bonus.listLabel ? <span className="font-semibold text-fg/80" data-id="element-30" data-mp="139wcz7cklay7">{bonus.listLabel} </span> : null}
            {bonus.items.join(' · ')}
          </p> : null}
        <p className="mt-auto pt-1.5 text-[0.8rem] font-semibold leading-snug text-accent" data-id="element-31" data-mp="ybuschzhx3km">
          {bonus.closingLabel ? `${bonus.closingLabel} ` : ''}
          {bonus.closing.join(' ')}
        </p>
      </div>
    </li>;
}